import { Box, Typography } from "@mui/material";

const ScatterNotesTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  // With the new chart we use ONE <Scatter /> series,
  // so payload[0].payload is always the hovered dot's data.
  const p = payload?.[0]?.payload;
  if (!p) return null;

  const productGroup = p.productGroup || "Product Group";
  const rating = p.ratingLabel || "-";
  const notes = p.notes || "";

  return (
    <Box
      sx={{
        bgcolor: "white",
        color: "#111827",
        p: 1.2,
        borderRadius: 2,
        maxWidth: 360,
        border: "1px solid rgba(15,23,42,0.12)",
        boxShadow: "0 10px 22px rgba(15,23,42,0.12)",
      }}
    >
      <Typography sx={{ fontWeight: 800, fontSize: "0.85rem" }}>
        {productGroup}
      </Typography>

      <Typography sx={{ fontSize: "0.78rem", opacity: 0.9, mt: 0.2 }}>
        Rating: <b>{rating}</b>
      </Typography>

      {!!notes && (
        <Typography sx={{ fontSize: "0.78rem", mt: 0.6, lineHeight: 1.35 }}>
          {notes}
        </Typography>
      )}
    </Box>
  );
};

export default ScatterNotesTooltip;
